export default {
    attribute:{ambientLightColor:'#999999',cabinetColor:'#2a52d4'},
    interaction:{intType: 'none'}
}